<template>
    <b-row class="pb-3" align-v="end">
        <b-col >
            <b-dropdown class="float-right">
                <template v-slot:button-content>
                    <img class="globe" src="@/assets/globe.png" /> {{$t('LANGUAGE_SELECT')}}
                </template>
                <b-dropdown-item v-for="language in displayLanguages()" v-bind:key="language.id" @click="selectLanguage(language.languageCode)">{{language.name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>
    </b-row>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "LanguageSelection",
        computed: Object.assign({},
            mapGetters({
                'language': 'shell/selectedLanguage'
            })
        ),
        methods: {
            selectLanguage: function (languageCode) {
                console.log(languageCode);
                this.$store.dispatch('shell/updateLanguage', languageCode);
            },
            displayLanguages() {
                var languageMapping = {
                    "en": "English",
                    "sp": "Español",
                    "jp": "日本語"
                }
                var activeLanguages = ['en', 'sp'];
                var languages = []
                activeLanguages.forEach(languageCode => {
                    languages.push({
                        "id": activeLanguages.indexOf(languageCode) + 1,
                        "name": languageMapping[languageCode],
                        "languageCode": languageCode,
                    })
                });
                return languages;

            }
        }
    };
</script>
<style scoped>
    .globe{
        padding-bottom: 2.7px;
        align-content: space-around;
        width: 20px;
        height: 20px;
        filter: invert(100%);
    }
</style>